
import * as React from 'react'
import { NavigationContainer } from '@react-navigation/native'
import { Login, Home } from './src/screens'
import { Nunito_400Regular, Nunito_600SemiBold, Nunito_700Bold, Nunito_900Black } from '@expo-google-fonts/nunito'
import * as Font from 'expo-font';
import AppLoading from 'expo-app-loading'
import { createStackNavigator } from '@react-navigation/stack'
import { SafeAreaProvider, SafeAreaView } from 'react-native-safe-area-context'
import { LocaleConfig } from 'react-native-calendars'
import { ModalCalendar, ModalFilter, ModalMerchant } from './src/components/index'
import Axios from 'axios'
import AsyncStorage from '@react-native-async-storage/async-storage'
import FlashMessage from "react-native-flash-message"
import { StatusBar } from 'expo-status-bar'
import { Text, TextInput } from 'react-native'

LocaleConfig.locales['vi'] = {
  monthNames: ['Tháng Một', 'Tháng Hai', 'Tháng Ba', 'Tháng Tư', 'Tháng Năm', 'Tháng Sáu', 'Tháng Bảy', 'Tháng Tám', 'Tháng Chín', 'Tháng Mười', 'Tháng Mười Một', 'Tháng Mười Hai'],
  monthNamesShort: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
  dayNames: ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'],
  dayNamesShort: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  today: 'Hôm nay'
}
LocaleConfig.defaultLocale = 'vi'

const Stack = createStackNavigator();

const MyTheme = {
  colors: {
    primary: '#FFC627',
    background: '#F1F1FA',
    process_1: 'rgba(255, 241, 178, 0.7)',
    process_2: 'rgba(48, 224, 161, 0.5)',
    process_3: 'rgba(250, 107, 107, 0.7)',
    process_background: '#EFEFFF',
    text: '#425486',
    text_sub: '#A1A9C3',
    text_yellow: '#FFC100',
    text_red: '#FA6B6B',
    text_green: '#3EA69B',
    text_orange: '#DC8744',
    bg_blue: '#96C0FF',
    bg_orange: '#FFBD86',
    bg_green: '#B3E59F'
  },
};

export default function App() {
  const [isReady, setIsReady] = React.useState(false)
  const [merchant, setMerchant] = React.useState()
  const navigationRef = React.useRef(null);

  let [fontsLoaded] = Font.useFonts({
    Nunito_400Regular, Nunito_600SemiBold, Nunito_700Bold, Nunito_900Black
  })

  React.useEffect(() => {
    Text.defaultProps = Text.defaultProps || {}
    Text.defaultProps.allowFontScaling = false
    TextInput.defaultProps = TextInput.defaultProps || {}
    TextInput.defaultProps.allowFontScaling = false
    TextInput.defaultProps.underlineColorAndroid = 'rgba(0,0,0,0)'

    const restoreState = async () => {
      try {
        const tmp = await AsyncStorage.getItem('merchant')
        let merchant = null
        if (tmp) merchant = JSON.parse(tmp)
        console.log(merchant)
        if (merchant) {
          Axios.defaults.baseURL = merchant.url
          Axios.defaults.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': merchant.token_type + ' ' + merchant.access_token,
            'partnerId': merchant?.partner_id
          }
        } else {
          Axios.defaults.baseURL = 'https://api.boc.vungtau.havaz.vn'
          // Axios.defaults.baseURL = 'https://dev.api.boc.vungtau.havaz.vn/'
          Axios.defaults.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }
        Axios.interceptors.response.use(response => {
          return response;
        }, error => {
          try {
            if (error.response.status === 401) {
              Axios.defaults.baseURL = 'https://api.boc.vungtau.havaz.vn'
              Axios.defaults.headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
              AsyncStorage.clear()
              setMerchant(null)
              navigationRef.current?.resetRoot({
                index: 0,
                routes: [{ name: 'Login' }],
              });
            }
          } catch (error) { }
          return error;
        });
        setMerchant(merchant)
      } finally {
        setIsReady(true);
      }
    }
    if (!isReady) {
      restoreState();
    }
  }, [])

  if (!fontsLoaded) {
    return <AppLoading />
  } else {
    if (!isReady) {
      return null
    } else return (
      <SafeAreaProvider>
        <StatusBar style="dark" />
        <NavigationContainer ref={navigationRef} theme={MyTheme}>
          <Stack.Navigator initialRouteName={merchant ? "Home" : "Login"} mode="modal" headerMode="screen">
            <Stack.Screen name="Login" component={Login} options={{ headerShown: false }} />
            <Stack.Screen name="Home" component={Home} options={{ headerShown: false }} />
            <Stack.Screen name="ModalCalendar" component={ModalCalendar} options={{ headerShown: false }} />
            <Stack.Screen name="ModalFilter" component={ModalFilter} options={{ headerShown: false }} />
            <Stack.Screen name="ModalMerchant" component={ModalMerchant} options={{ headerShown: false }} />
          </Stack.Navigator>
        </NavigationContainer>
        <FlashMessage position="top" floating={true} />
      </SafeAreaProvider>
    )
  }
}